import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SharedVehicleGroupModel } from '../models/sharedvehiclegroup.model';
import { SharedVehicleGroupService } from '../models/sharedvehiclegroup.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel, WeGoAuthorizedLink, Permission, PermissionType, RoleLevel } from '../../shared/config';

@Component({
  selector: 'wego-sharedvehiclegroup-list',
  template: require('../views/sharedvehiclegroup-list.component.html'),
  providers: [SharedVehicleGroupService],

})
export class SharedVehicleGroupListComponent implements OnInit {
  DataListModel: DataListModel;
  sharedVehicleGroupList: SharedVehicleGroupModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  message: string;
  validationMessage: string;
  urlDefaultPage: string;
  urlSVGAdd:string;
  urlSVGUpdate: string;
  urlSVGAdminList: string;
  deleteSharedVehicleGroupHashId: string;
  isMultipleDelete: boolean;
  apiResponse: IAPIResponse;
  isParentCheck: boolean;
  companyHashID: string = "";
  urlVehicleList: string;
  urlDriverList: string;
  urlContractTypeGroupList: string;
  urlSubscriptionList: string;
  lblActive: string;
  lblInactive: string;
  blockUnblockMsg: string;
  blockUnblockSVGHashId: string;
  blockMsg: string;
  vehicleHashId: string;
  urlVehicleMasterList: string;
  addSharedVehicleGroupLink: WeGoAuthorizedLink;
  roleLevel = RoleLevel;

  private popupMsg: string;
  private module: string
  private breadCrumbList: string;
  private urlAdminList:string;


  @ViewChild('deleteModal') public deleteModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('inActiveModal') public inActiveModal: any;

  get isAnyChecked(): boolean {
    if (this.sharedVehicleGroupList) {
      let isCheck = this.sharedVehicleGroupList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.sharedVehicleGroupList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.sharedVehicleGroupList){
      return this.sharedVehicleGroupList.some(x => x.isDeletable);
    }
    else{ return false; }
      
  }

  constructor(private sharedVehicleGroupService: SharedVehicleGroupService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router, private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblSharedVehicleGroup');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    console.log('ngOnInit');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    
    if(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company){
      this.DataListModel.searchField = ["groupName", "companyName"];
    }else{
      this.DataListModel.searchField = ["groupName"];
    }
    
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlSVGAdd = this.authService.GetURL(ApplicationRouteURL.URL_SVG_ADD);
    this.urlSVGUpdate = this.authService.GetURL(ApplicationRouteURL.URL_SVG_UPDATE);
    this.urlSVGAdminList = this.authService.GetURL(ApplicationRouteURL.URL_SVGADMIN_LIST);
    this.urlSubscriptionList = this.authService.GetURL(ApplicationRouteURL.URL_SUBSCRIPTION_LIST);
    this.urlVehicleList = this.authService.GetURL(ApplicationRouteURL.URL_SVGVEHICLE_LIST);
    this.urlDriverList = this.authService.GetURL(ApplicationRouteURL.URL_SVGDRIVER_LIST);
    this.urlContractTypeGroupList = this.authService.GetURL(ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST);
    this.urlVehicleMasterList = this.authService.GetURL(ApplicationRouteURL.URL_VEHICLE_LIST);
    this.urlAdminList =  this.authService.GetURL(ApplicationRouteURL.URL_ADMIN_OF_SHAREDVEHICLEGROUP_LIST);

    this.activeRoute
      .params
      .subscribe(params => {
        let companyHashID = params['companyHashId'] || '';
        if (companyHashID != '')
          this.companyHashID = companyHashID;
        else
          this.companyHashID = "";

        let vehicleHashId = params['vehicleHashId'] || '';
        if (vehicleHashId != '')
          this.vehicleHashId = vehicleHashId;
        else
          this.vehicleHashId = "";


        this.GetSharedVehicleGroupList();
      });

      this.addSharedVehicleGroupLink = new WeGoAuthorizedLink(this.urlSVGAdd, 
        Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSharedVehicleGroupList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetSharedVehicleGroupList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSharedVehicleGroupList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSharedVehicleGroupList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.sharedVehicleGroupService.ExportSharedVehicleGroupList(this.companyHashID, this.vehicleHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "SVG" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetSharedVehicleGroupList() {
    this.isLoading = true;
    this.sharedVehicleGroupService.GetSharedVehicleGroupList(this.DataListModel, '', this.companyHashID, this.vehicleHashId)
      .subscribe(
      res => {
        this.sharedVehicleGroupList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnParentCheck(isChecked: boolean) {
    this.sharedVehicleGroupList.filter(x => x.isDeletable).forEach(x => x.isChecked = isChecked);
  }
  public DeleteSharedVehicleGroup(deletecontractTypeHashId: string[]) {
    this.isLoading = true;
    this.sharedVehicleGroupService.DeleteSharedVehicleGroup(deletecontractTypeHashId)
      .subscribe(
      res => {
        this.apiResponse = res;
        this.DataListModel.currentPage = 1;
        this.GetSharedVehicleGroupList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public ShowDeleteModal(sharedVehicleGroupHashId?: string): void {
    if (sharedVehicleGroupHashId) {
      this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteSharedVehicleGroupHashId = sharedVehicleGroupHashId;
    }
    else {
      this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.deleteModal.show();
  }

  public HideDeleteModal(): void {
    this.deleteSharedVehicleGroupHashId = "";
    this.deleteModal.hide();
  }

  public SuccessModalClick(): void {
    let deleteContractTypeList: any[];
    if (this.isMultipleDelete)
      deleteContractTypeList = this.sharedVehicleGroupList.filter(x => x.isChecked).map(x => x.sharedvehiclegroupHashId);
    else
      deleteContractTypeList.push(this.deleteSharedVehicleGroupHashId);

    this.DeleteSharedVehicleGroup(deleteContractTypeList)
    this.deleteModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ActiveInactiveSVG() {
    this.isLoading = true;
    this.sharedVehicleGroupService.InActiveSharedVehicleGroup(this.blockUnblockSVGHashId)
      .subscribe(
      (res: any) => {
        if (res.data) {
          this.inActiveModal.hide();
          this.DataListModel.currentPage = 1;
          this.GetSharedVehicleGroupList();
          this.popupMsg = this.translate.instant('LblRecordActiveInActiveSuccess', [this.module, this.blockMsg]);
          this.ShowSuccessPopup();
        }
        else {
          this.isLoading = false;
          this.popupMsg = res.error;
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowInActiveModal(svgHashId: string, isActive: boolean): void {
    this.blockUnblockSVGHashId = svgHashId;
    this.blockMsg = isActive ? this.translate.instant('LblInactive') : this.translate.instant('LblActive');
    let roleType = this.translate.instant('LblSharedVehicleGroup');
    this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [this.blockMsg, roleType]);
    this.inActiveModal.show();
  }

  public HideInActiveModal(): void {
    this.inActiveModal.hide();
  }

  public SuccessInActiveModalClick(): void {
    this.ActiveInactiveSVG();
    this.inActiveModal.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroup/components/sharedvehiclegroup-list.component.ts